module.exports = __webpack_public_path__ + "static/media/file.dcce5401.svg";